module.exports = "/_next/static/images/uzuna_menu_alchol-7b399e33930a7aac1505f2d51aa01c2d.jpg";